import * as DropdownMenu from '@studio/design-system/dropdown-menu';
import type { HtmlAttributes } from '@studio/design-system/props';
import type { ReactElement } from 'react';
import { useAddAudio } from '../audio/hooks.js';
import { useAddVideo } from '../video/hooks.js';
import { Sel, STag } from '#~/stag/tag.js';

/** `<Add>` component. */
export const Add = (props: HtmlAttributes): ReactElement => {
  const addVideo = useAddVideo();
  const addAudio = useAddAudio();

  return (
    <div {...props}>
      <DropdownMenu.Root>
        <DropdownMenu.Trigger asChild>
          <DropdownMenu.Ikon icon='plus' {...STag(Sel.MainRoomLeftTrayHeader, 'add')} />
        </DropdownMenu.Trigger>

        <DropdownMenu.Content align='start' side='right'>
          <DropdownMenu.Item
            icon='source'
            label='Add video source'
            onSelect={addVideo}
            {...STag(Sel.MainRoomLeftTrayHeader, 'add-dropdown', 'video')}
          />
          <DropdownMenu.Item
            icon='audio'
            label='Add audio source'
            onSelect={addAudio}
            {...STag(Sel.MainRoomLeftTrayHeader, 'add-dropdown', 'audio')}
          />
        </DropdownMenu.Content>
      </DropdownMenu.Root>
    </div>
  );
};
